import { render } from "./FeaturedElement.vue?vue&type=template&id=1e2dae24"
import script from "./FeaturedElement.vue?vue&type=script&lang=js"
export * from "./FeaturedElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/apps/FeaturedElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e2dae24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e2dae24', __exports__)) {
    api.reload('1e2dae24', __exports__)
  }
  
  module.hot.accept("./FeaturedElement.vue?vue&type=template&id=1e2dae24", () => {
    api.rerender('1e2dae24', render)
  })

}


export default __exports__